// ----------------------------------------------------------------------------
// Template: 404
// ----------------------------------------------------------------------------
// 404 File Not Found Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-header/page-header';

// Styles
import './_404.scss';
